import { FormattedMessage } from 'react-intl';
import messages from './messages';

export const HEADERS = [
  {
    id: 'tracsStatus',
    label: <FormattedMessage {...messages.tracsStatus} />,
    info: <FormattedMessage {...messages.tracsTooltip} />,
    dataType: 'string',
    sortable: true,
    searchable: true,
    multiselect: true,
  },
  {
    id: 'unitNumber',
    label: <FormattedMessage {...messages.unit} />,
    dataType: 'string',
    sortable: true,
    searchable: true,
  },
  {
    id: 'hudUnitNumber',
    label: <FormattedMessage {...messages.hudUnitNumber} />,
    info: <FormattedMessage {...messages.hudUnitNumberTooltip} />,
    dataType: 'string',
    sortable: true,
    searchable: true,
  },
  {
    id: 'floorPlan',
    label: <FormattedMessage {...messages.floorPlan} />,
    dataType: 'string',
    sortable: true,
    searchable: true,
    multiselect: true,
  },
  {
    id: 'headOfHousehold',
    label: <FormattedMessage {...messages.headOfHousehold} />,
    dataType: 'string',
    sortable: true,
    searchable: true,
  },
  {
    id: 'effectiveDate',
    label: <FormattedMessage {...messages.effectiveDate} />,
    dataType: 'date',
    sortable: true,
    searchable: true,
  },
  {
    id: 'certificationType',
    label: <FormattedMessage {...messages.certificationType} />,
    dataType: 'string',
    sortable: true,
    searchable: true,
    multiselect: true,
  },
  {
    id: 'certComplete',
    label: <FormattedMessage {...messages.certComplete} />,
    dataType: 'string',
    sortable: true,
    searchable: true,
    multiselect: true,
  },
  {
    id: 'recertDueDate',
    label: <FormattedMessage {...messages.recertificationDueDate} />,
    dataType: 'date',
    sortable: true,
    searchable: true,
  },
  {
    id: 'correction',
    label: <FormattedMessage {...messages.correction} />,
    dataType: 'string',
    sortable: true,
    searchable: true,
    multiselect: true,
  },
  {
    id: 'assistanceAmount',
    label: <FormattedMessage {...messages.subsidyRent} />,
    dataType: 'number',
    sortable: true,
    searchable: true,
  },
  {
    id: 'actions',
    label: <FormattedMessage {...messages.actions} />,
  },
];

export const PROPERTY_PATH_MAP = {
  tracsStatus: { path: 'tracsStatus', dataType: 'string' },
  unitNumber: { path: 'unitNumber', dataType: 'string' },
  hudUnitNumber: { path: 'hudNumber', dataType: 'string' },
  floorPlan: {
    path: 'floorPlan',
    dataType: 'string',
  },
  headOfHousehold: {
    path: 'headOfHousehold',
    dataType: 'string',
  },
  effectiveDate: {
    path: 'effectiveDate',
    dataType: 'date',
  },
  certificationType: { path: 'certificationType', dataType: 'string' },
  certComplete: { path: 'certComplete', dataType: 'string' },
  recertDueDate: { path: 'recertDueDate', dataType: 'date' },
  correction: { path: 'correction', dataType: 'string' },
  assistanceAmount: { path: 'assistanceAmount', dataType: 'number' },
  actions: { path: 'actions', dataType: 'string' },
};
